import React from "react";
import { useIntl } from "react-intl";

import Seo from "../../../../common/helpers/seo";

import Hero from "../home/Hero";

import messages from "../home/messages";
import { StyledHome } from "../home/styles";
import { useUser } from "../../../store/user/selectors";
import Why from "./Why";
import Features from "./Features";

const Home = () => {
    const { formatMessage } = useIntl();
    const user = useUser();
    return (
        <StyledHome marginTop={50} withShadow>
            <Seo
                title={`Musicators - ${formatMessage(messages.slogen)}`}
                description={formatMessage(messages.description)}
                app="choir"
            />
            <Hero forChoirs />
            <Why />
            <Features />
        </StyledHome>
    );
};

export default Home;
